import * as React from 'react';

// @ts-expect-error
import AircallWorkspace from 'aircall-everywhere';
import classnames from 'classnames';

import {AircallIcon} from 'shells/icon/svg/aircall-icon';

import {addNotification} from '../../notifications/index';

import styles from './aircall-workspace-mount.module.css';

const AIRCALL_WORKSPACE_ID = 'aircall-workspace';

export function AircallWorkspaceMount() {
    const [isCollapsed, setIsCollapsed] = React.useState<boolean>(true);

    const workspaceRef = React.useRef<any>(null);
    const containerRef = React.useRef<HTMLDivElement | null>(null);
    const buttonRef = React.useRef<HTMLButtonElement | null>(null);
    const hasInitialized = React.useRef<boolean>(false);

    React.useEffect(() => {
        if (!hasInitialized.current) {
            hasInitialized.current = true;

            workspaceRef.current = new AircallWorkspace({
                domToLoadWorkspace: `#${AIRCALL_WORKSPACE_ID}`,
                size: 'small',
                debug: false,
            });

            workspaceRef.current.on('incoming_call', () => {
                setIsCollapsed(false);
            });

            // Expose dial function globally for sending call events to the widget from anywhere in the app (ex. call button on entity pages)
            // @ts-expect-error
            window.dialAircall = (phoneNumber: string) => {
                if (workspaceRef.current && workspaceRef.current.send) {
                    setIsCollapsed(false);
                    workspaceRef.current.send(
                        'dial_number',
                        {phone_number: phoneNumber},
                        // @ts-expect-error
                        (success, _data) => {
                            if (!success) {
                                addNotification(
                                    'Unable to open the Aircall widget with this number',
                                    {
                                        icon: 'frowny',
                                        body: 'Please open the widget, ensure you are logged in, and try again.',
                                    }
                                );
                            }
                        }
                    );
                }
            };
        }

        return () => {
            // @ts-expect-error
            if (window.dialAircall) {
                // @ts-expect-error
                delete window.dialAircall;
            }
        };
    }, []);

    // Handle click outside to collapse
    React.useEffect(() => {
        if (isCollapsed) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (
                containerRef.current &&
                event.target instanceof Node &&
                !containerRef.current.contains(event.target)
            ) {
                if (buttonRef.current) {
                    buttonRef.current.blur();
                }
                setIsCollapsed(true);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCollapsed]);

    const workspaceStyleName = classnames(styles['aircall-workspace'], {
        [styles['aircall-workspace-collapsed']]: isCollapsed,
        [styles['aircall-workspace-expanded']]: !isCollapsed,
    });

    const buttonClassName = isCollapsed ? 'nut-navbar--button' : 'nut-navbar--button--active';

    const handleButtonClick = () => {
        if (!isCollapsed && buttonRef.current) {
            buttonRef.current.blur();
        }
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div ref={containerRef} className={styles['aircall-widget-container']}>
            <button
                ref={buttonRef}
                type='button'
                className={buttonClassName}
                onClick={handleButtonClick}
                data-tip='Aircall'
                data-place='bottom'
                data-delay-show={50}
            >
                <AircallIcon size={20} wrapWithDiv={false} />
            </button>
            <div id={AIRCALL_WORKSPACE_ID} className={workspaceStyleName} />
        </div>
    );
}
